// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DI8dl0_SmA88WhNKbz2Q{flex-direction:row;justify-content:space-between;align-items:center;gap:12px;margin-bottom:56px;display:flex}.kME2rgwhKkIOBic39gfu{border:1px solid var(--interaction-neutral-normal);background:var(--content-primary-primary-inverted);border-radius:8px;flex-direction:column;justify-content:center;align-items:center;width:100%;height:84px;padding:20px;display:flex}.BdT6w6SBq0hm9c5nr6uW{margin-bottom:4px}.UvQmp4fmu_c81jiHEpeu{min-width:125px;line-height:normal;text-decoration:none}.WM4_yChamU1q4H2EtI1Q{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DI8dl0_SmA88WhNKbz2Q`,
	"content": `kME2rgwhKkIOBic39gfu`,
	"count": `BdT6w6SBq0hm9c5nr6uW`,
	"helpButton": `UvQmp4fmu_c81jiHEpeu`,
	"fileInput": `WM4_yChamU1q4H2EtI1Q`
};
export default ___CSS_LOADER_EXPORT___;
